import { useState } from 'react'
import { KeywordResponse } from '../../../types'
import { ProjectInterface } from '../../../interfaces/ProjectInterface'
import usePaginationModel from '../../../hooks/usePaginationModel'
import useSortModel from '../../../hooks/useSortModel'
import * as CONSTANTS from '../../../utils/Constants';

const OpportunityKeywordsModel = () => {
  const [ isLoading, setIsLoading ] = useState<Record<string, boolean>>({ search: false, export: false, projects: false, keywords: false });
  const [ projectsData, setProjectsData ] = useState<ProjectInterface>()
  const [ projectSelected, setProjectSelected ] = useState('')
  const [ url, setUrl ] = useState('')
  const [ keywordsData, setKeywordsData ] = useState<any>()

  // Pagination and Sorting in server side
  const[ filter, setFilter ] = useState(new Map())
  const { paginationModel, setPaginationModel } = usePaginationModel()
  const { sortModel, setSortModel } = useSortModel()
  const [ modeFilter, setModeFilter ] = useState(CONSTANTS.ALL_FILTER_MODE_OPPORTUNITY[0]);

  return {
    isLoading, setIsLoading,
    projectsData, setProjectsData,
    projectSelected, setProjectSelected,
    url, setUrl,
    keywordsData, setKeywordsData,

    filter, setFilter,
    paginationModel, setPaginationModel,
    sortModel, setSortModel,
    modeFilter, setModeFilter
  }
}

export default OpportunityKeywordsModel

/*
import { useState } from 'react';
import { useProjectsData } from '../../../hooks/useProjectsData';
import { ProjectInterface } from '../../../interfaces/ProjectInterface';
import useProjectsFilters from '../../../hooks/useProjectsFilters';
import useRangesDate from '../../../hooks/useRangesDate';
import * as CONSTANTS from '../../../utils/Constants';
import useExportData from '../../../hooks/useExportData';

const OpportunityKeywordsModel = () => {

  const {
    clicksOfSearches, hasClicksOfSearches, defaultValueClicks, handleClicksOfSearches,
    impressionsOfSearches, hasImpressionsOfSearches, defaultValueImpression, handleImpressionsOfSearches,
    positionOfSearches, hasPositionsOfSearches, defaultValuePositions, handlePositionOfSearches,
    ctrOfSearches, hasCtrOfSearches, defaultValueCtr, handleCtrOfSearches,
    handleFiltersApply
  } = useProjectsFilters();
  const { rangesDate, handleChangeRanges } = useRangesDate();
  const [dataKeyword, setDataKeyword] = useState<any[]>([]);

  const { fetchExportProjectsKeywords, isLoading: isExportLoading } = useExportData();

  const [project, setProject] = useState<ProjectInterface>({ property: null });
  const [url, setUrl] = useState<string>()

  const { loadingKeywords, dataProject,  fetchKeywords } = useProjectsData();

  type FilterModeType = (typeof CONSTANTS.ALL_FILTER_MODE_OPPORTUNITY)[number];
  const [filterMode, setFilterMode] = useState<FilterModeType>(
    CONSTANTS.ALL_FILTER_MODE_OPPORTUNITY[0]
  );


  return {
    project, setProject,
    loadingKeywords, dataProject, fetchKeywords,
    url, setUrl,
    clicksOfSearches, hasClicksOfSearches, defaultValueClicks, handleClicksOfSearches,
    impressionsOfSearches, defaultValueImpression, hasImpressionsOfSearches, handleImpressionsOfSearches,
    positionOfSearches, hasPositionsOfSearches, defaultValuePositions, handlePositionOfSearches,
    ctrOfSearches, hasCtrOfSearches, defaultValueCtr, handleCtrOfSearches,
    handleFiltersApply,
    rangesDate, handleChangeRanges,
    dataKeyword, setDataKeyword,
    filterMode, setFilterMode,
    fetchExportProjectsKeywords, isLoading: isExportLoading
  }
}

export default OpportunityKeywordsModel

 */